import React, { useContext, useMemo } from 'react';

import { ReportFilterMultiSelect } from '../../../../../../components/report-filter-buttons/report-filter-multi-select';
import Select from '../../../../../../components/select/select';
import { STRIKE_REPORT_DISPLAY } from '../../../../../../providers/strike-report';
import { StrikeReportContext } from '../../../../../../providers/strike-report';
import './styles.scss';

export const StrikeReportHeader: React.FC = () => {
  const {
    strikeReportFilters: {
      strikeReportFilterToken,
      setStrikeReportFilterToken,
      strikeReportFilterDisplay,
      setStrikeReportFilterDisplay,
    },
  } = useContext(StrikeReportContext);

  const renderTokenSelect = useMemo(() => {
    const defaultTokenList = strikeReportFilterToken.tokenList.filter(
      (filterToken) => filterToken.isDefault,
    )[0];

    if (!defaultTokenList) return <></>;

    return (
      <Select
        defaultValue={
          strikeReportFilterToken.tokenList.filter((filterToken) => filterToken.isDefault)[0]
        }
        values={strikeReportFilterToken.tokenList}
        onChange={(token: string) =>
          setStrikeReportFilterToken((state: any) => ({ ...state, token }))
        }
        className="token-select"
        label="Token"
      />
    );
  }, [strikeReportFilterToken]);

  return (
    <div className="strike-report-header">
      {strikeReportFilterToken.tokenList.length > 0 && renderTokenSelect}
      <ReportFilterMultiSelect
        titleFilter="Display"
        dataArr={STRIKE_REPORT_DISPLAY}
        selected={strikeReportFilterDisplay}
        setSelected={setStrikeReportFilterDisplay}
      />
    </div>
  );
};
